import * as actionTypes from './actionTypes'
import axios from '../../httpClients/axios-datamerch'
import {authHeaders} from '../../helpers'
import {addToast} from './toasts'

export const fetchBrokersStart = () => {
  return {
    type: actionTypes.FETCH_BROKERS_START
  }
}

export const fetchBrokersSuccess = (brokers, pagination) => {
  return {
    type: actionTypes.FETCH_BROKERS_SUCCESS,
    brokers: brokers,
    pagination: pagination
  }
}

export const fetchBrokersFail = (error) => {
  return {
    type: actionTypes.FETCH_BROKERS_FAIL,
    error: error
  }
}

export const fetchBrokers = (page, per_page, search, sort) => {
  return dispatch => {
    dispatch(fetchBrokersStart())
    let url = `/brokers?page=${page + 1}&per_page=${per_page}&search=${encodeURIComponent(search)}&sort=${encodeURIComponent(sort)}`
    let config = authHeaders()
    axios.get(url, config)
    .then(response => {
      if (response){
        const fetchedBrokers = []
        const pagination = response.data.pagination
        for(let key in response.data.data){
          fetchedBrokers.push({
            ...response.data.data[key],
            id: key
          })
        }
        dispatch(fetchBrokersSuccess(fetchedBrokers, pagination))
      } else {
        dispatch(fetchBrokersFail('An error occurred while attempting to retrieve brokers.'))
        dispatch(addToast({
          message: 'An error occurred while attempting to retrieve brokers.',
          severity: 'error',
          duration: null
        }))
      }
    })
    .catch(error => {
      dispatch(fetchBrokersFail(error.response.data.errors))
      dispatch(addToast({
        message: error.response.data.errors,
        severity: 'error',
        duration: null
      }))
    })
  }
}

export const fetchBrokerNotesStart = (broker_name) => {
  return {
    type: actionTypes.FETCH_BROKER_NOTES_START,
    broker_name: broker_name
  }
}

export const fetchBrokerNotesSuccess = (broker_name, notes) => {
  return {
    type: actionTypes.FETCH_BROKER_NOTES_SUCCESS,
    broker_name: broker_name,
    notes: notes
  }
}

export const fetchBrokerNotesFail = (broker_name, error) => {
  return {
    type: actionTypes.FETCH_BROKER_NOTES_FAIL,
    broker_name: broker_name,
    error: error
  }
}

export const fetchBrokerNotes = (broker_name) => {
  return dispatch => {
    dispatch(fetchBrokerNotesStart(broker_name))
    let url = `/brokers/notes?broker_name=${encodeURIComponent(broker_name)}`
    let config = authHeaders()
    axios.get(url, config)
    .then(response => {
      if (response){
        const fetchedNotes = []
        for(let key in response.data.data){
          fetchedNotes.push({
            ...response.data.data[key],
            id: key
          })
        }
        dispatch(fetchBrokerNotesSuccess(broker_name, fetchedNotes))
      } else {
        dispatch(fetchBrokerNotesFail(broker_name, 'An error occurred while attempting to retrieve broker notes.'))
        dispatch(addToast({
          message: 'An error occurred while attempting to retrieve broker notes.',
          severity: 'error',
          duration: null
        }))
      }
    })
    .catch(error => {
      dispatch(fetchBrokerNotesFail(broker_name, error.response.data.errors))
      dispatch(addToast({
        message: error.response.data.errors,
        severity: 'error',
        duration: null
      }))
    })
  }
}
